import { Icon, LinkButton, MediaImage, Page, PathButton } from "shared/react";
import { pluralizeCompactQuantity } from "shared/util/number";
import { getMediaImageStyle } from "shared/util/style";
import { EmbedMarkup } from "../misc/EmbedMarkup.js";
import { useMemberData } from "../util/data.js";
import { useGroupContext } from "./GroupContext.js";
import { GroupJoinPanel } from "./GroupJoinPanel.js";
import { GroupNavigation } from "./GroupNavigation.js";
import { MemberStatusBadge } from "./MemberStatusBadge.js";

export function GroupAboutPage(): React.ReactElement {
	const group = useGroupContext();
	const { id: gid, name, photo, username, about, cover, hue, location, website, members } = group;
	const member = useMemberData(gid);
	const { status } = member;
	return (
		<Page>
			<header className="panel pad-none" style={getMediaImageStyle(cover, hue)}>
				<div className="pad-3x">
					<figure className="photo size-5x">{photo ? <MediaImage path={photo} /> : <Icon icon="chat" />}</figure>
					<h1 className="space-xsmall">
						<small className="label">Group</small>
						<span>{name}</span> {username ? <small>{`@${username}`}</small> : null}
					</h1>
					<p className="space-xsmall flex-row flex-center gap-xsmall size-small">
						<MemberStatusBadge status={status} />
					</p>
					<p className="flex-row flex-center size-small gap-hairline">
						<PathButton path="../members" mods="button-quiet">
							{pluralizeCompactQuantity(members, "member", "members")}
						</PathButton>
						{website ? <LinkButton href={website} mods="button-quiet" /> : null}
						{location ? (
							<LinkButton href={`https://www.google.com/maps?q=${encodeURIComponent(location)}`} mods="button-quiet">
								{location}
							</LinkButton>
						) : null}
					</p>
				</div>
				{status !== null ? <GroupNavigation gid={gid} /> : null}
			</header>
			{about ? (
				<section>
					<EmbedMarkup>{about}</EmbedMarkup>
				</section>
			) : null}
			<GroupJoinPanel gid={gid} group={group} member={member} />
		</Page>
	);
}
